import React, { Component } from 'react';
import { radar } from './radar';
import { IColumn, ISeries } from './radarTypes';
import { defaults } from './radarUtil';

import './radarChart.scss';

interface IRadarChartProps {
    columns: IColumn;
    series: ISeries[];
    rangeMax: number;
    aiVoiceCheckSwitch?: number;
}

export default class RadarChart extends Component<IRadarChartProps, {}> {
    public render() {
        const { columns } = this.props;
        let bottom = 120;
        const len = Object.keys(columns).length;
        switch (len) {
            case 3:
                bottom = 100;
                break;

            case 4:
                bottom = 132;
                break;

            case 5:
                bottom = 118;
                break;

            case 6:
                bottom = 130;
                break;
        }
        const viewBox = `-25 -10 150 ${bottom}`;
        return (
            <svg className="radar-chart" viewBox={viewBox}>
                <g dangerouslySetInnerHTML={{ __html: this.getChart() }} />
            </svg>
        );
    }

    private getChart() {
        const { columns, series, aiVoiceCheckSwitch, rangeMax } = this.props;

        for (let i = 0; i < series.length; i++) {
            const item = series[i];
            const keys = Object.keys(columns);
            keys.map((key) => {
                let val = item[key] as number;
                val = val > rangeMax ? rangeMax : val;
                item[key] = val / rangeMax;
            });
        }

        const chart = radar(
            columns,
            series,
            Object.assign({}, defaults, {
                aiVoiceCheckSwitch,
                scales: 5,
                rangeMax,
                shapeProps: (data: IColumn) => {
                    return {
                        className: 'shape ' + data.class,
                    };
                },
            }),
        );
        return chart;
    }
}
